// extracted by mini-css-extract-plugin
export default {"footer":"SectionFooter_footer__qdp-p","footer_text":"SectionFooter_footer_text__z+Kp6","transparent":"SectionFooter_transparent__3Ij4z"};